
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ReportingApi from "@/services/reporting-api";
import SalesPerformance from "./SalesPerformance.vue";
import { mapGetters } from 'vuex';
import { frLocale, frRanges } from "@/datePickerConfig.js";

/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports Vente",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, SalesPerformance},

  
  computed:{
     ...mapGetters('menu', ['menuCampaignId', "menuCampaign"]),
  },

  data(){
    const now = new Date();
    const currentYear = now.getFullYear();

    return{
      
      range: {
            startDate: new Date(`${currentYear}-01-01`),
            endDate: now,
          },

      frLocale,
      frRanges,
      globalMetric:null,

      salesPerformancePageChart:1,
      salesPerformancePageSize:10,
      salesPerformanceData:null,
      salesPerformanceChartKey:0,
      activeIndex: 0,

    }
  },

  watch:{

    menuCampaignId:function(){

      this.showConfigureQRCode = false
      this.initReportingCustomerCompnent()

    },


    range:function(){
      this.initReportingCustomerCompnent()  
    }


    },

  mounted(){
    this.initReportingCustomerCompnent()
  },

  methods:{

    initReportingCustomerCompnent(){
      this.getGlobalMetric()
      this.getSalesPerformanceData(0)

    },


    formatDate(date) {
      return new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

    // API CALL //

    getSalesPerformanceData(type) {
      this.activeIndex = type;

      
      if(!this.range || !this.range.startDate || !this.range.endDate){
        return;
      }

      if(!this.menuCampaignId){
        return;
      }
      

      const params = {
        page: this.salesPerformancePageChart,
        pageSize: this.salesPerformancePageSize,
        campaignId: this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      const apiMap = {
        0: ReportingApi.getHourlyDashboardStats,
        1: ReportingApi.getDailyDashboardStats,
        2: ReportingApi.getWeeklyDashboardStats,
        3: ReportingApi.getMonthlyDashboardStats
      };

      const request = apiMap[type];

      if (request) {
        request(params).then((res) => {
          if (res) {
            this.salesPerformanceData = res;
            this.salesPerformanceChartKey++;
          }
        });
      }
    },

    getGlobalMetric(){

      if(!this.range || !this.range.startDate || !this.range.endDate){
        return;
      }

      if(!this.menuCampaignId){
        return;
      }

      const params = {
        menuCampaignId: this.menuCampaignId == null ? null : this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };


      ReportingApi.getGlobalMetric(params).then(
        (result) => {
          if (result) {
            this.globalMetric = result;
          }
        }
      );
    },

  }
}
</script>

<template>
  <Layout>

    <div class="home-page-80-width">


      <div class="my-4 mx-1">
        <div class="row">
          
          <div class="col-lg-9 col-md-7 col-12 mb-2 mb-md-0">
            <h4 class="global-metric-title">Ventes</h4>
            <div style="font-size: 11px;" v-if="menuCampaign && menuCampaign.customerName">
                Client: <a href="#" class="text-primary">{{ menuCampaign.customerName }}</a> | <a href="#" class="text-primary">{{ menuCampaign.menuName }}</a>
            </div>
            <small class="text-muted"> {{ formatDate(new Date()) }}</small>
          </div>

          <div class="col-lg-3 col-md-5 col-12 text-right">
            <v-dateRangePicker
              ref="picker"
              v-model="range"
              :autoApply="true"
              :locale-data="frLocale"
              opens="left"
              :ranges="frRanges"
            />
          </div>

        </div>
      </div>



      <div v-if="globalMetric" class="d-flex flex-wrap" style="gap: 10px;">
        <b-card class="text-center global-metric-card p-3 mx-1" >
          <div class="global-metric-title mb-1">{{ globalMetric.dailyTurnover }}</div>
          <div class="text-uppercase text-dark" style="font-size: 0.75rem;">
            Chiffre d'affaires du jour
          </div>
        </b-card>

        <b-card class="text-center global-metric-card p-3 mx-1" >
          <div class="global-metric-title mb-1">{{globalMetric.openTableTurnover}}</div>
          <div class="text-uppercase text-dark" style="font-size: 0.75rem;">
            Chiffre d’affaires tables ouvertes
          </div>
        </b-card>

        <b-card class="text-center global-metric-card p-3 mx-1" >
          <div class="global-metric-title mb-1">{{ globalMetric.orderCount }}</div>
          <div class="text-uppercase text-dark" style="font-size: 0.75rem;">
            Nombre de commandes
          </div>
        </b-card>

        <b-card class="text-center global-metric-card p-3 mx-1" >
          <div class="global-metric-title mb-1">{{ globalMetric.currentlyActiveTable }}</div>
          <div class="text-uppercase text-dark" style="font-size: 0.75rem;">
            Tables ouvertes à l'instant
          </div>
        </b-card>

        <b-card class="text-center global-metric-card p-3 mx-1" >
          <div class="global-metric-title mb-1">{{ globalMetric.dailyAvgTicket }}</div>
          <div class="text-uppercase text-dark" style="font-size: 0.75rem;">
            Ticket moyen du jour
          </div>
        </b-card>
      </div>



    <div class="my-4">
      <b-card class="text-left global-metric-card p-3 mx-1">
      
        <div class="row d-flex">
        
          <div class="col-md-6 text-uppercase text-dark font-weight-bold font-size-14 mb-4">
            Performance des ventes
          </div>


          <!-- <div class="col-md-6 col-12 d-flex justify-content-end">
            <div>
              <img alt="left" class="mr-2" width="17px" src="@/assets/icons/left-2.svg" style="cursor: pointer;"/>
              <span class="text-center mr-2">page {{salesPerformancePageChart}}</span>              
              <img alt="right" width="17px" src="@/assets/icons/right-2.svg" style="cursor: pointer; " :style="{ opacity: salesPerformancePageChart === 1 ? 0.5 : 1, pointerEvents: salesPerformancePageChart === 1 ? 'none' : 'auto' }"                    />
            </div>
            <div>
              <select class="custom-select custom-select-sm ml-2"  v-model="salesPerformancePageSize">
                <option selected value="10">10</option>
                <option value="30">30</option>
              </select>
            </div>
          </div> -->
        </div>

        <div class="d-flex justify-content-end my-3">
          <div class="toggelsButtons d-flex flex-wrap" role="group" aria-label="Fréquence de rapport">
            <div
              class="toggels-button"
              :class="{ active: activeIndex === 0 }"
              @click="getSalesPerformanceData(0)"
            >
              Horaire
            </div>
            <div
              class="toggels-button"
              :class="{ active: activeIndex === 1 }"
              @click="getSalesPerformanceData(1)"
            >
              Quotidien
            </div>
            <div
              class="toggels-button"
              :class="{ active: activeIndex === 2 }"
              @click="getSalesPerformanceData(2)"
            >
              Hebdomadaire
            </div>
            <div
              class="toggels-button"
              :class="{ active: activeIndex === 3 }"
              @click="getSalesPerformanceData(3)"
            >
              Mensuel
            </div>
          </div>
        </div>

          <SalesPerformance
            :key="salesPerformanceChartKey"
            :campaignId="this.menuCampaignId"
            :salesPerformanceData="salesPerformanceData == null ? null : salesPerformanceData"  />

      </b-card>
    </div>


      </div>


  </Layout>
</template>












<style>

.period-card{
  background-color: #fff;
  color: #000;
  border-radius: 8px;
  padding: 9px 11px;
  color: #334155;
  font-weight: 500;
  border: 1px solid #ddd;
}

.global-metric-title{
  font-weight: bold;
  font-size: 30px;
  color: #000;
}

.global-metric-card{
  border-radius: 16px;
  border: 1px solid #ddd;
  flex: 1 1 200px;
}

.previewMenuButton{
  background: linear-gradient(135deg, #f4b740, #D4AF37);
  color: #fff;
  letter-spacing: 0.7px;
  line-height: 20px;
  font-weight: bold;
}



/*  */

.toggelsButtons{
  background-color: #F1F5F9;
  border-radius: 20px;
  padding: 0px 10px;
}

.toggels-button {
  font-weight: 600;
  border-radius: 9999px;
  padding: 0.5rem 1.2rem;
  margin: 5px 0px;
  user-select: none;
  transition: background-color 0.3s ease;
}

.toggels-button:hover {
  background-color: #fff;
  color: black;
  cursor: pointer;
}

.toggels-button.active {
  background-color: #fff;
  color: black;
}




</style>